module.exports = __webpack_public_path__ + "static/img/about-us-page-banner.6dec0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-us-page-banner.png
// module id = dl4/
// module chunks = 0